<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>USUARIO</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="alertCambiarClave();">
          <fa :icon="['fad', 'user-unlock']" class="fa-fw" style="font-size:20px;"></fa>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-grid v-if="cargando || cargandoEmpresas || cargandoSucursales || cargandoTipoUsuario" class="ion-text-center ion-margin-top ion-padding-top">
      <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
        <ion-col size="12">
          <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
        </ion-col>
        <ion-col size="12">
          <ion-label color="dark">CARGANDO...</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list v-else>
      <ion-item>
        <ion-label position="floating">Rut</ion-label>
        <ion-input maxlength="12" :value="usuario.rutFormateado" readonly></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Nombres</ion-label>
        <ion-input v-model="usuario.usr_nombres"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Apellido paterno</ion-label>
        <ion-input v-model="usuario.usr_apellido_p"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Apellido materno</ion-label>
        <ion-input v-model="usuario.usr_apellido_m"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label class="text-lowercase" position="floating">Correo</ion-label>
        <ion-input v-model="usuario.usr_correo"></ion-input>
      </ion-item>
       <ion-item>
        <ion-label position="floating">Telefono</ion-label>
        <ion-input inputmode="tel" type="tel" v-model="usuario.usr_telefono" maxlength="9" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"></ion-input>
      </ion-item> 
      <ion-item>
        <ion-label position="floating">Empresa</ion-label>
        <ion-select placeholder="SELECCIONA UNO" v-model="usuario.usr_empresa" cancel-text="CANCELAR" ok-text="ACEPTAR"
          @ionChange="listarSucursales(usuario.usr_empresa); listarTiposUsuario(usuario.usr_empresa); usuario.usr_sucursal=''; usuario.usr_tipo_usuario='';">
          <ion-select-option v-for="empresa in empresas" :key="empresa.emp_id+'emp'" :value="empresa.emp_id">{{empresa.emp_nombre}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Sucursal</ion-label>
        <ion-select :disabled="usuario.usr_empresa==''" placeholder="SELECCIONA UNO" v-model="usuario.usr_sucursal" cancel-text="CANCELAR" ok-text="ACEPTAR">
          <ion-select-option v-for="sucursal in sucursales" :key="sucursal.suc_id+'loc'" :value="sucursal.suc_id">{{sucursal.suc_nombre}}</ion-select-option>
          <ion-select-option :value="''">NINGUNA</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Tipo usuario</ion-label>
        <ion-select :disabled="usuario.usr_empresa==''" placeholder="SELECCIONA UNO" v-model="usuario.usr_tipo_usuario" cancel-text="CANCELAR" ok-text="ACEPTAR">
          <ion-select-option v-for="tipo in tiposUsuario" :key="tipo.tpu_id+'tpu'" :value="tipo.tpu_id">{{tipo.tpu_nombre}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="fixed">Habilitado</ion-label>
        <ion-toggle
          slot="end" color="success"
          @ionChange="usuario.usr_activo = !usuario.usr_activo"
          :checked="usuario.usr_activo">
        </ion-toggle>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Ultima conexión</ion-label>
        <ion-input disabled v-model="usuario.usr_ultimo_acceso"></ion-input>
      </ion-item>
    </ion-list>
  </ion-content>

  <ion-footer>
    <ion-grid>
      <ion-row>
        <ion-col>
            <ion-button @click="cerrarModal()" color="danger" shape="round" expand="block">
                <ion-label>CERRAR</ion-label>
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button :disabled="!validaDatos()" @click="guardarUsuario();" color="success" shape="round" expand="block">
                <ion-label>GUARDAR</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-footer>
</template>

<script>
import { modalController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, 
      IonLabel, IonItem, IonInput, IonSpinner, IonList, IonSelect, IonSelectOption, IonToggle, toastController, alertController } from '@ionic/vue';
import { defineComponent } from 'vue';
import { addIcons        } from 'ionicons';
import { arrowBackOutline, trashOutline, settingsOutline, keyOutline } from 'ionicons/icons';
import { Preferences     } from '@capacitor/preferences';
import { cerrarSesion    } from '@/plugins/funciones';
import axios               from 'axios';
import rutaBase            from '@/plugins/variables';

export default defineComponent({
  name: 'ModalVerUsuario',
  props: {
    usuarioProp   : Object,
    modal         : Object
  },
  components: { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, IonLabel, 
  IonItem, IonInput, IonSpinner, IonList, IonSelect, IonSelectOption, IonToggle },
  data(){
    return {
      cargando              : false,
      cargandoEmpresas      : false,
      cargandoSucursales    : false,
      cargandoTipoUsuario   : false,
      usuario               : {},
      empresas              : [],
      sucursales            : [],
      tiposUsuario          : []
    }
  },
  created() {
    addIcons({
      'arrow-back-outline'  : arrowBackOutline,
      'trash-outline'       : trashOutline,
      'settings-outline'    : settingsOutline,
      'key-outline'         : keyOutline

    });
  },
  mounted(){
    this.usuario = JSON.parse(JSON.stringify(this.usuarioProp));
    this.usuario.rutFormateado = this.formateaRut(this.usuario.usr_rut+this.usuario.usr_dv);
    this.listarEmpresas();
    this.listarSucursales(this.usuario.usr_empresa);
    this.listarTiposUsuario(this.usuario.usr_empresa);
  },
  methods:{
    async listarEmpresas(){
      this.cargandoEmpresas   = true;
      const token             = await Preferences.get({ key: 'token_auth' });
      const headers           = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/administrador/listarEmpresasPorRut', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargandoEmpresas = false;
        this.empresas = resp.data.empresas;
      }).catch(() =>{
        this.cargandoEmpresas = false;
        this.muestraToast('ERROR AL OBTENER EMPRESAS.');
      });
    },

    async listarSucursales(idEmpresa){
      this.cargandoSucursales = true;
      const token           = await Preferences.get({ key: 'token_auth' });
      const headers         = { headers: { 'Authorization': `${token.value}` } };
      const dato            = new URLSearchParams();
      dato.append('id_empresa', idEmpresa);
      axios.post(rutaBase+'/administrador/listarSucursalesPorEmpresa', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargandoSucursales = false;
        this.sucursales  = resp.data.sucursales;
      }).catch(() =>{
        this.cargandoSucursales = false;
        this.muestraToast('ERROR AL OBTENER SUCURSALES.');
      });
    },

    async listarTiposUsuario(idEmpresa){
      this.cargandoTipoUsuario  = true;
      const token               = await Preferences.get({ key: 'token_auth' });
      const headers             = { headers: { 'Authorization': `${token.value}` } };
      const dato                = new URLSearchParams();
      dato.append('id_empresa', idEmpresa);
      axios.post(rutaBase+'/administrador/listarTiposUsuarioPorEmpresa', dato, headers).then( resp => {
        this.cargandoTipoUsuario = false;
        this.tiposUsuario = resp.data.tiposUsuario;
      }).catch(() =>{
        this.cargandoTipoUsuario = false;
        this.muestraToast('ERROR AL OBTENER TIPOS USUARIO.');
      });
    },

    async guardarUsuario(){
      this.cargando  = true;
      const token               = await Preferences.get({ key: 'token_auth' });
      const headers             = { headers: { 'Authorization': `${token.value}` } };
      const dato                = new URLSearchParams();
      dato.append('usuario', JSON.stringify(this.usuario));
      axios.post(rutaBase+'/administrador/guardarUsuario', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargando = false;
        if(resp.data.key == 1){
          this.muestraToast('DATOS REGISTRADOS CORRECTAMENTE.');
          this.cerrarModal({recargar:true});
        }
        else{
          this.muestraToast('A OCURRIDO UN ERROR.');
        }
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL REGISTRAR DATOS.');
      });
    },

    async reestablecerClave(){
      this.cargando  = true;
      const token               = await Preferences.get({ key: 'token_auth' });
      const headers             = { headers: { 'Authorization': `${token.value}` } };
      const dato                = new URLSearchParams();
      dato.append('rut', this.usuario.usr_rut.toString());
      axios.post(rutaBase+'/administrador/reestablecerClave', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargando = false;
        if(resp.data.key == 1){
          this.muestraToast('CLAVE CAMBIADA CON EXITO.');
        }
        else{
          this.muestraToast('A OCURRIDO UN ERROR.');
        }
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL REGISTRAR DATOS.');
      });
    },

    validaDatos(){
      if(
        this.usuario.usr_nombres      != ''   &&
        this.usuario.usr_apellido_p   != ''   &&
        this.usuario.usr_apellido_m   != ''   &&
        this.usuario.usr_correo       != ''   &&
        this.usuario.usr_telefono             &&
        this.usuario.usr_sucursal     != ''   &&
        this.usuario.usr_sucursal     != null   
      ){
        if(this.usuario.usr_telefono.length == 9  && !Number.isNaN(parseInt(this.usuario.usr_telefono)) ){
          return true;
        }
      }
      return false;
    },


    async cerrarModal(dato=null){
      modalController.dismiss(dato);
    },

    async alertCambiarClave() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'REESTABLECER CLAVE',
          message: '¿DESEA ENVIAR UNA NUEVA CLAVE AL USUARIO?',
          buttons: [
            {
              text: 'CANCELAR',
              role: 'cancel',
              cssClass: 'secondary',
              handler: blah => {
                console.log('Confirm Cancel:', blah)
              },
            },
            {
              text: 'ENVIAR',
              role: 'ok',
              cssClass: 'primary',
              handler: () => {
                this.reestablecerClave()
              },
            },
          ],
        });
      return alert.present();
    },

    formateaRut(rut){
      const newRut = rut.replace(/\./g,'').replace(/[^k|K|\d]/g, '').replace(/-/g, '').trim().toUpperCase();
      const lastDigit = newRut.substr(-1, 1);
      const rutDigit = newRut.substr(0, newRut.length-1)
      let format = '';
      let i = 0;
      let j = 1;
      for (i = rutDigit.length - 1; i >= 0; i--) {
        const e = rutDigit.charAt(i);
        format = e.concat(format);
        if (j % 3 == 0 && j <= rutDigit.length - 1) {
          format = '.'.concat(format);
        }
        j++;
      }
      let formateado = "";
      if(format.length > 0){
        formateado = format.concat('-').concat(lastDigit);
      }
      else{
        formateado = lastDigit;
      }
      return formateado;
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
  }
});
</script>

<style scoped>
.alert-wrapper.sc-ion-alert-md {
  min-width:350px !important;
  max-width:none !important;
}
</style>